'use client';

import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

interface SatisfiedClientsCardProps {
  count: string;
  avatars: Array<{
    src: string;
    alt: string;
    fallback?: string;
  }>;
  className?: string;
}

export function SatisfiedClientsCard({ count, avatars, className }: SatisfiedClientsCardProps) {
  const getZIndex = (index: number) => {
    const zIndexMap: Record<number, string> = {
      0: 'z-30',
      1: 'z-20',
      2: 'z-10',
    };
    return zIndexMap[index] || 'z-0';
  };

  return (
    <div className={cn('bg-brand-blue rounded-3xl p-6 md:px-6 md:py-5 flex items-center gap-4', className)}>
      <div className='flex -space-x-4 shrink-0'>
        {avatars.map((avatar, index) => (
          <Avatar 
            key={`${avatar.src}-${index}`}
            className={cn(
              'border-2 border-brand-blue w-10 h-10 relative',
              getZIndex(index)
            )}
          >
            <AvatarImage src={avatar.src} alt={avatar.alt} />
            <AvatarFallback className='bg-brand-violet-300 text-brand-violet-900 text-sm font-medium'>
              {avatar.fallback || avatar.alt.charAt(0).toUpperCase()}
            </AvatarFallback>
          </Avatar>
        ))}
      </div>
      <p className='text-white text-base md:text-lg font-medium'>{count}</p>
    </div>
  );
}
